import { gql } from '@apollo/client';

export const GET_COMPANY_THEME_SETTINGS = gql`
  query getCompanyThemeSettings($companyId: String) {
    getCompanyThemeSettings(companyId:$companyId) {
      mode
      theme
      radius
      style
      skin
      dir
    }
  }
`